module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rafael Sabatini\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rafael Sabatini (1875–1950) was an Italian writer of adventure and romance novels. The author of over thirty works, he is best remembered for "), _c('I', [_vm._v("Scaramouche")]), _vm._v(","), _c('I', [_vm._v(" The Sea Hawk")]), _vm._v(", and "), _c('I', [_vm._v("Captain Blood")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aptDMV/tc-custom/9781504017268.jpg?1703675905370",
      "alt": "This image is the cover for the book Captain Blood"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Captain Blood\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A thrilling tale of piracy, justice, and honor on the high seas from the author of "), _c('i', [_vm._v("Scaramouche")])]), _c('br'), _c('br'), _vm._v(" Retired soldier Peter Blood lives a happy, comfortable life as a physician in seventeenth-century England. Yet everything changes one fateful evening when he saves the life of the wrong patient: a young rebel involved in an uprising against King James II. For doing his job and obeying the Hippocratic oath, the shell-shocked Blood is convicted of treason and sentenced to ten years in Barbados, toiling as a slave."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Once in the Caribbean, however, Blood has other plans. The daring doctor wins over his peers with his courage and skill, falls in love with the plantation owner’s niece, and begins to plot his escape. When a Spanish privateer attacks the plantation town, Blood seizes his chance, and with the help of his fellow slaves, pulls off a daring heist of the pirates’ ship. Based on a true story, "), _c('i', [_vm._v("Captain Blood")]), _vm._v(" is an immensely satisfying high-seas adventure for the ages."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This ebook has been professionally proofread to ensure accuracy and readability on all devices."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0